export enum MigratingAccountDecision {
  USE_PARENT_ACCOUNT = 'USE_PARENT_ACCOUNT',
  CREATE_ACCOUNT = 'CREATE_ACCOUNT',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT'
}